var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3420.04 882.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b4dbf0;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: #79c4ea;\n      }\n\n      .cls-6 {\n        fill: #231f20;\n      }\n\n      .cls-7 {\n        fill: #1aaee3;\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-9 {\n        fill: #51c4d5;\n      }\n\n      .cls-10 {\n        fill: #eac528;\n      }\n\n      .cls-11 {\n        fill: #3291cf;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -979.08,
    y1: -31.47,
    x2: -1135.91,
    y2: 212.87,
    gradientTransform: "translate(2491.97 128.85) scale(2.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3194d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1ebce6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83cdc2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -763.28,
    y1: 90.64,
    x2: -931.85,
    y2: 329,
    gradientTransform: "translate(2491.97 128.85) scale(2.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85cec1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#20bce5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3291cf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1047.17,
    y1: 189.25,
    x2: -1046.95,
    y2: 353.77,
    gradientTransform: "translate(2491.97 128.85) scale(2.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#368dcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1ebae5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67c7cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -863.13,
    y1: -58.73,
    x2: -859.95,
    y2: 110.6,
    gradientTransform: "translate(2491.97 128.85) scale(2.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#78cbc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1ebce6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#378ccb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M511.35,255.23c-66.78,85.88-132.39,173.14-198.7,259.32-1.12-.01-2.25.01-3.37,0-60.55-.6-121.31.19-181.86,0-35.51-.11-82.58,3.87-116.37.01-9.98-1.14-8.81,2.2-8.24-10.12,6.73-25.76,193.59-348.29,215.54-373.83l3.37-3.37c1.07-1.17,2.26-2.23,3.37-3.37C370.6-26.39,544.7,34.17,511.35,255.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M689.85,373.1c70.83.5,243.1-17.49,301.51-3.41,9.46,2.28,3.78,6.36,4.96,13.51-73.19,117.62-131.43,250.44-212.17,363.72-2.15,3.02-5.99,9.19-6.74,10.1-8.03,9.79-3.74,5.09-16.84,20.21-23.41,27.02-88.93,57.77-124.44,62.47-144.04,19.08-150.05-105.36-144.99-214.03,65.62-83.69,128.02-170.19,195.33-252.59,1.12,0,2.25,0,3.37,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.42,517.92c60.55-.19,121.32-.44,181.86,0,17.81,9.76,139.71-1.77,144.84,3.35,3.38,3.37-5.1,61.04,3.35,70.74.23,13.43-.23,26.98,0,40.41.17,10.07-.34,20.25,0,30.31,3.95,118.28,8.45,200.11,151.55,212.17-12.36,2.18-24.58,2.46-37.05,3.37-63.52,4.63-172.78,5.43-235.75,0-70.98-6.12-135.29-42.64-181.95-95.9-25.32-28.9-143.13-222.45-151.47-254.36-.56-12.32-1.74-8.98,8.24-10.12,33.78-3.86,80.85.12,116.37.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M999.69,366.37c-103.21-.59-206.63.79-309.84,0-9.34-9.98-136.46,1.65-141.47-3.35-3.17-3.17,4.95-49.04-3.35-57.27-.62-28.8,3.31-59.36-3.37-87.56-2.87-103.86-12.2-220.29-154.92-205.44,7.52-4.9,19.69-6.32,28.53-6.83,166.7-9.58,340.39-25.89,449.06,120.3,17.58,23.65,134.11,223.33,135.35,240.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M773.79,761.49c-26.56,45.94-112.68,104.24-164.77,113.41-143.1-12.06-147.6-93.89-151.55-212.17,12.13-10.92,23.67-24.28,33.68-37.05-5.06,108.67.95,233.1,144.99,214.03,35.5-4.7,110.65-54.81,137.66-78.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M386.74,12.75c142.71-14.85,152.05,101.57,154.92,205.44.03,1.12-.03,2.25,0,3.37-8.21,11.2-22.43,23.54-30.31,33.68C544.7,34.17,363.86-19.66,218.35,130.62c27.34-48.85,112.89-112.1,168.39-117.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M999.69,366.37c.44,5.96,1.1,11.94-3.37,16.84-1.18-7.15,4.5-11.23-4.96-13.51-58.42-14.08-230.68,3.91-301.51,3.41-.41-1.89.62-6.07,0-6.74,103.21.79,206.62-.59,309.84,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M571.97,878.27h-235.75c62.97,5.43,172.23,4.63,235.75,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2.81,504.45c-.56,12.32-1.73,8.98,8.24,10.12,33.78,3.86,80.86-.12,116.37-.01v3.37c-35.51.11-82.58-3.87-116.37-.01-9.98,1.14-8.81-2.2-8.24,10.12-3.75-14.36-3.75-9.22,0-23.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M218.35,130.62c1.03-1.2,2.3-2.2,3.37-3.37l-3.37,3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M541.66,221.55c.55,20.35-5.26,142.96-.02,148.2,5.12,5.12,126.18,3.2,144.84,3.35-67.32,82.39-129.72,168.89-195.33,252.59-10.01,12.77-21.55,26.13-33.68,37.05-.34-10.06.17-20.24,0-30.31,5.05-14.19,5.75-112.14.21-116.4s-125.94-1.27-145.03-1.47c66.31-86.19,131.93-173.44,198.7-259.32,7.88-10.13,22.1-22.48,30.31-33.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M309.28,514.55v3.37c-60.55-.44-121.31-.19-181.86,0v-3.37c60.56.19,121.31-.6,181.86,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M457.47,632.42c-.23-13.43.23-26.98,0-40.41-.18-10.67,2.64-71.49.02-74.11-5.24-5.24-128.4.16-148.2.02v-3.37c1.12.01,2.25-.01,3.37,0,19.09.21,139.28-2.95,145.03,1.47s4.84,102.21-.21,116.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M545.03,305.75c.2,9.11-2.16,58.5-.02,60.64,5.12,5.12,125.43-.17,144.84-.02.62.67-.41,4.85,0,6.74-1.12,0-2.25,0-3.37,0-18.65-.15-139.71,1.77-144.84-3.35-5.24-5.24.57-127.85.02-148.2-.03-1.12.03-2.25,0-3.37,6.67,28.2,2.75,58.77,3.37,87.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M309.28,517.92c19.8.14,142.96-5.26,148.2-.02,2.62,2.62-.2,63.44-.02,74.11-8.45-9.7.03-67.37-3.35-70.74-5.12-5.12-127.03,6.41-144.84-3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M545.03,305.75c8.3,8.23.18,54.11,3.35,57.27,5,5,132.12-6.63,141.47,3.35-19.41-.15-139.72,5.14-144.84.02-2.14-2.14.22-51.53.02-60.64Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1290.42,172.26c44.52,0,81.99,14.99,112.4,44.96,30.41,29.98,45.62,66.78,45.62,110.42s-15.21,80.45-45.62,110.42c-30.41,29.98-67.88,44.96-112.4,44.96h-81.32v152.07h-91.24V172.26h172.57ZM1290.42,397.72c19.39,0,35.48-6.72,48.27-20.17,12.78-13.44,19.17-30.08,19.17-49.92s-6.39-37.03-19.17-50.25c-12.79-13.22-28.88-19.84-48.27-19.84h-81.32v140.17h81.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1733.41,304.49h85.29v330.59h-85.29v-39.01c-25.57,32.18-61.49,48.27-107.77,48.27s-81.88-16.86-113.39-50.58c-31.52-33.72-47.27-75.04-47.27-123.97s15.75-90.25,47.27-123.97c31.51-33.72,69.31-50.58,113.39-50.58,46.28,0,82.2,16.1,107.77,48.27v-39.01ZM1576.05,536.89c17.19,17.42,39.01,26.12,65.46,26.12s48.37-8.7,65.79-26.12,26.12-39.77,26.12-67.11-8.71-49.69-26.12-67.11c-17.42-17.41-39.34-26.12-65.79-26.12s-48.27,8.71-65.46,26.12c-17.19,17.42-25.79,39.78-25.79,67.11s8.6,49.7,25.79,67.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2111.6,304.49h91.24l-120.53,331.12c-17.19,47.2-39.98,81.5-68.37,102.91-28.4,21.39-63.73,30.99-105.98,28.79v-79.34c22.91.43,41.1-4.41,54.55-14.55,13.44-10.14,24.13-26.45,32.07-48.93l-135.54-320.01h93.23l86.21,222.2,73.13-222.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2523.51,259.53h-185.13v109.75h179.84v87.27h-179.84v178.52h-91.24V172.26h276.37v87.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2586.32,635.08V152.42h85.29v482.66h-85.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2821.69,504.83c11.46,41.44,42.53,62.15,93.23,62.15,32.62,0,57.29-11.01,74.05-33.06l68.76,39.67c-32.62,47.17-80.66,70.75-144.14,70.75-54.66,0-98.51-16.53-131.57-49.59-33.06-33.06-49.59-74.71-49.59-124.96s16.3-91.34,48.93-124.63c32.61-33.28,74.49-49.92,125.62-49.92,48.48,0,88.48,16.76,120,50.25,31.51,33.5,47.27,74.94,47.27,124.3,0,11.02-1.11,22.71-3.31,35.04h-249.26ZM2820.37,438.71h168.6c-4.86-22.48-14.88-39.23-30.08-50.25-15.21-11.01-32.51-16.53-51.9-16.53-22.92,0-41.88,5.85-56.86,17.52-14.99,11.68-24.91,28.1-29.75,49.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M3420.05,635.08h-98.51l-71.74-100.2-71.74,100.2h-98.52l121.17-168.75-115.88-161.83h98.51l66.69,93.13,66.87-93.13h97.85l-115.71,161.61,120.99,168.98Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlack);
export default __webpack_public_path__ + "static/media/black.61d92f26120cd4071b7049147458ac9d.svg";
export { ForwardRef as ReactComponent };